import API from "./restApi";
import { AxiosResponse } from "axios";

let config = require("../configuration/config");

export function apiGetCurrentUser(): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/currentuser`);
}
